import { render, staticRenderFns } from "./PromoList.vue?vue&type=template&id=7857ce32&scoped=true&"
import script from "./PromoList.vue?vue&type=script&lang=js&"
export * from "./PromoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857ce32",
  null
  
)

export default component.exports